import { Image } from '@gasbuddy/react-components';
import classnames from 'classnames/bind';
import PropTypes from 'prop-types';
import { useCallback, useMemo } from 'react';
import useDelay from '../../../lib/hooks/useDelay';
import useProfile from '../../../lib/hooks/useProfile';
import { noop } from '../../../lib/utils';
import { COUNTRY_CODES } from '../../constants';
import StationPropType from '../../prop-types/station';
import styles from './PwGBBanner.module.css';
import useConfig from '../../../lib/hooks/useConfig';

const cx = classnames.bind(styles);

export default function PwGBBanner({
  onBannerLoaded,
  onClick,
  station,
}) {
  const { isPayUser } = useProfile();
  const { enrollHost } = useConfig();

  const { address, hasActiveOutage } = station;

  const showPWGBBanner = useMemo(() => !isPayUser && address?.country === COUNTRY_CODES.USA && !hasActiveOutage, [address.country, hasActiveOutage, isPayUser]);

  const bannerHasLoaded = useCallback(() => {
    onBannerLoaded();
  }, [onBannerLoaded]);

  // delay the image src so the onLoad event can attach to the element for cached images coming from SSR
  const showImg = useDelay({ begin: true, duration: 100 });

  if (!showPWGBBanner) {
    onBannerLoaded();
    return null;
  }

  return (
    <a
      href={`https://${enrollHost}`}
      onClick={onClick}
    >
      <Image
        alt="Pay With GasBuddy Banner - Never Pay Full Price. Join and save up to 25¢/gal"
        className={cx('pwgbBanner')}
        fluid
        lazy={false}
        onLoad={bannerHasLoaded}
        onError={bannerHasLoaded}
        src={showImg ? 'https://static.gasbuddy.com/web/pay/pwgb-station-banner.png' : ''}
      />
    </a>
  );
}

PwGBBanner.propTypes = {
  onBannerLoaded: PropTypes.func,
  onClick: PropTypes.func,
  station: StationPropType,
};
PwGBBanner.defaultProps = {
  onBannerLoaded: noop,
  onClick: noop,
  station: undefined,
};
